import * as angular from 'angular';

export class HardToken {

    constructor(dto) {
        angular.extend(this, dto);
    }

    toDto() {
        const dto = angular.extend({}, this);

        // do not send secrets if they're empty
        dto.secret = dto.secret || undefined;
        dto.privateIdentity = dto.privateIdentity || undefined;

        return dto;
    }

    get effectiveStatus() {
        return this.hasAccounts ? this.status : 'NOT_ASSIGNED';
    }
}



// WEBPACK FOOTER //
// ./src/portal/models/hard-token.js